import { ACTIONS_KEYS, MUTATIONS_KEYS } from '../../store';
import { createWires } from '../wiring.util';
import { WIRE_FACTORY } from './wires.factory';

export const RECOMMENDATIONS_WIRES = createWires({
  /* No results recommendations */
  getNoResultsRecommendations: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.noResults.getRecommendations),
  getNoResultsRecommendationsIfNotPresent: WIRE_FACTORY.dispatchActionConditionally(
    { ifAction: ACTIONS_KEYS.noResults.getRecommendations },
    (_, store) => !store.state.noResults.recommendations.recommendations.length),
  enableNoResultsInfiniteScrollRecommendations: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.noResults.setInfiniteScrollEnabled, true),
  disableNoResultsInfiniteScrollRecommendations: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.noResults.setInfiniteScrollEnabled, false),
  increaseNoResultsRecommendationsPage: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.noResults.increasePage),
  clearNoResultsRecommendations: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.noResults.clearRecommendations),
  /* Empty search recommendations */
  getEmptySearchRecommendations: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.emptySearch.getRecommendations),
  enableEmptySearchInfiniteScrollRecommendations: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.emptySearch.setInfiniteScrollEnabled, true),
  disableEmptySearchInfiniteScrollRecommendations: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.emptySearch.setInfiniteScrollEnabled, false),
  increaseEmptySearchRecommendationsPage: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.emptySearch.increasePage),
  clearEmptySearchRecommendations: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.emptySearch.clearRecommendations)
});
